import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import LoadingOverlay from 'react-loading-overlay';
import { isEqual } from 'lodash';

import { policyFetch, customerFetch, validateCart, calculateCart, customerFindByNumber, SelectPayment } from '../../../actions';
import { Card, Checkbox, Modal } from '../../../helpers';
import { commonConstant, CustomCheckbox, StickyBottom } from '../../../common';
import { activityService } from '../../../services';
import AmwayRedirect from '../../redirect/Redirect';
import { excludeProductEntries } from '../../../helpers/Products/excludeProductEntries';
import RenewalPersonalInfoCard from '../../../common/renewalPersonalInfoCard/RenewalPersonalInfoCard';
import RenewalOrderDetailCard from '../../../common/renewalOrderDetailCard/RenewalOrderDetailCard';
import { LABEL_ACCEPT_TNC_ABO_RENEWAL, LABEL_ACCEPT_TNC_MEMBER_RENEWAL } from '../../../common/commonConstant';

import { handlePriceFormatting, thaiDate } from '../../../utill.func';
import './ConfirmPayment.scss';
import { liffGetProfile } from '../../../services/promotion/auth.service';
import { PlaceOrders } from '../../../services/promotion/payment.service';

export const RenewConfirmPayment = () => {// order-detail page for member upgrade
  const cartRef = useRef();
  const checkboxRef = useRef(null);
  const [showConsent, setShowConsent] = useState(false);
  const [isCalculated, setCalculated] = useState(false);
  const [accept, setAccept] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isAutoRenewal, setIsAutoRenewal] = useState(false);
  const [redirect, setRedirect] = useState();
  const [modalContent, setModalContent] = useState();
  const [partyIndex, setPartyIndex] = useState(-1);
  const { customer, cart, pickStore, find } = useSelector(state => state);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const sendAvtivity = useCallback((status) => {
    activityService.create({
      uid: customer.uid,
      userId: customer._id,
      status: status,
      action: 'CONFIRM_PAYMENT_FOR_MAGAZINE',
    });
  });

  useEffect(() => {
    // dispatch(addrFetch(customer.amwayNumber));
    dispatch(customerFindByNumber(customer.amwayNumber));
    dispatch(customerFetch(customer.amwayNumber));
    dispatch(validateCart(customer.amwayNumber, customer.partyId, cart.data.code));
  }, []);

  useEffect(() => {
    if (cart.validate && !isEqual(cart?.validate, cartRef?.current?.validate) && cart.validate.code === 200) {
      dispatch(calculateCart(customer.amwayNumber, customer.partyId, cart.data.code,));
    } else if (cart.calculated && ((cart.calculated !== cartRef?.current?.calculated) || cartRef?.current?.calculated)) {
      setCalculated(true);
    } else if (cart.validate && cart.validate.code !== 200) {
      handleToggleModal('ERROR');
    }
    cartRef.current = cart;
  }, [cart]);

  useEffect(() => {
    if (showConsent) {
      dispatch(policyFetch({ accountSubTypeCd: customer.type === 'member' ? 'MEMBER' : 'BusinessOwner' }));
    }
  }, [showConsent]);

  useEffect(() => {
    if (find?.partyList?.length && customer.partyId) {
      const index = find.partyList.findIndex(party => party.partyMst.partyId === customer.partyId);
      if (index !== -1) {
        setPartyIndex(index);
      }
    }

    if (find?.subscriptionList?.length) {
      const autoRenewSubscription = find.subscriptionList?.find(
        item => item.subscriptionName === 'Auto-Renewal' && item.subscriptionId === '50' && item.subscribeFlag === 'Y'
      );

      if (autoRenewSubscription) {
        setIsAutoRenewal(true);
        return;
      }

      setIsAutoRenewal(false);
    }
  }, [find]);

  useEffect(() => {
    if (!redirect) return;

    const handleRedirect = async () => {
      try {
        if (isAutoRenewal) {
          handleToggleModal('AUTO_RENEWAL');
          return;
        }
        const { userId } = await liffGetProfile();
        const order = await PlaceOrders(cart.data.code, userId);
        if (order && !order.isNotValid) {
          const urlWithOrderId = `/?seamless=${process.env.REACT_APP_NGC_STOREFRONT_URL}/checkout-retry/${order.orderNumber}`;
          window.open(urlWithOrderId, "_self");
        }
      } catch (error) {
        handleToggleModal('ERROR');
      } finally {
        setRedirect(false);
      }
    };

    handleRedirect();
  }, [redirect]);

  const handleToggleModal = (content = '') => {
    setModalContent(content);
    setShowModal(show => !show);
  };

  const secondaryOnClick = () => {
    history.push({ pathname: commonConstant.pathChooseMag, search: '?backFromPayment=true' });
  }

  // if (!address.data){
  //   return <div> <LoadingOverlay
  //     active={true}
  //     spinner
  //     text="Loading"
  //     styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', pointerEvents: 'none' } }}
  //   /></div>;
  // } else {
  //   const addrList = address.data.addressBookList[0].addressList[0];
  //   addr = `${` ${addrList.addrStreet}`}${` ${addrList.addrLineTwo}`}${` ${addrList.addrLineThree}`}${` ${addrList.addrLineFour}`} ${addrList.cityName} ${addrList.postalCd}`;
  // }

  if (!cart.data || !cart.calculated || !find.accountMst) {
    return <div> <LoadingOverlay
      active={true}
      spinner
      text="Loading"
      styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', pointerEvents: 'none' } }}
    /></div>;
  }
  if (showConsent) {
    return <PaymentConsent setAccept={() => setAccept(true)} onClick={() => setShowConsent(!showConsent)} />;
  }

  const handleAddressRender = ({ type, deliveryType }) => {
    switch (type) {
      case 'electronic':
        return (
          <>
            <div className="card-header">
              ชุดเริ่มต้นธุรกิจ
            </div>
            <div className="card-body">
              <div className="header">[ E - Starter Kit ]</div>
              <div>
                รับส่วนลด 150 บาท ในการซื้อสินค้า
              </div>
            </div>
          </>
        );
      case 'physical':
        if (deliveryType === 'atShop' && cart.data.pickupOrderGroups) {
          return (
            <>
              <div className="card-header">
                ข้อมูลการจัดส่ง
              </div>
              <div className="card-body">
                <div className="header">[ {cart.data.deliveryMode.name} ]</div>
                <div>
                  {pickStore.data.entry.deliveryPointOfService.displayName}
                </div>
                <div>
                  {pickStore.data.entry.deliveryPointOfService.address.line1.replace(/<\/?[^>]+(>|$)/g, '')}
                </div>
              </div>
            </>
          );
        }
        return (
          <>
            <div className="card-header">
              ข้อมูลการจัดส่ง
            </div>
            <div className="card-body">
              <div className="header">[ จัดส่งที่อยู่บ้าน (ที่อยู่ปัจจุบัน) ]</div>
              <div>
                ชุดคู่มือนักธุรกิจแอมเวย์แบบรูปเล่ม
              </div>
              <div>
                {cart.data.account.primaryParty.defaultAddress.formattedAddress}
              </div>
            </div>
          </>
        );
      default:
        return;
    }
  };

  const CustomerTypeRenderMapping = {
    abo: {
      cardText: location.state.type === 'electronic' ? 'รับนิตยสารอะชีฟรูปแบบอิเล็กทรอนิกส์' : 'รับนิตยสารอะชีฟแบบรูปเล่ม',
      cardImg: location.state.type === 'electronic' ? '/images/renewalAndUpgrade/E-StarterKit-Renewal.png' : '/images/renewalAndUpgrade/PhysicalKit.svg',
      title: location.state.type === 'physical' && 'วิธีการจัดส่ง',
      desc: location.state.type === 'physical' ?
        location.state.deliveryType === 'atShop' ?
          [`รับด้วยตัวเอง : ${pickStore && pickStore?.data?.entry?.deliveryPointOfService?.displayName}`] :
          [`จัดส่ง : ${cart.data && cart.data?.account?.primaryParty?.defaultAddress?.formattedAddress}`] :
        []
    },
    member: {
      cardText: 'ชุดคู่มือสมาชิก',
      cardImg: '/images/renewalAndUpgrade/MemberRenewal.svg',
      title: 'วิธีการจัดส่ง',
      desc: location.state.deliveryType === 'atShop' ?
        [`รับด้วยตัวเอง : ${pickStore && pickStore?.data?.entry?.deliveryPointOfService?.displayName}`] :
        [`จัดส่ง : ${cart.data && cart.data?.account?.primaryParty?.defaultAddress?.formattedAddress}`]
    },       // for multi line description
  }

  const handleModalContent = () => {
    switch (modalContent) {
      case 'ERROR':
        return {
          content: 'เกิดข้อพิดพลาด กรุณาลองใหม่ในภายหลัง',
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'ปิด',
          fnOk: () => history.replace(commonConstant.pathChooseMag),
        };
      case 'NO_PHONE':
        return {
          content: ' ไม่พบข้อมูลเบอร์มือถือ กรุณาติดต่อ Amway Contact Center 027258000',
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'โทร',
          fnOk: () => window.location = 'tel:027258000',
        };
      case 'AUTO_RENEWAL':
        return {
          content: 'ไม่สามารถทำการต่ออายุได้ เนื่องจากมีคำสั่งซื้อต่ออายุอื่นแล้ว',
          type: 'warning',
          cancleBtn: false,
          okBtn: true,
          okText: 'ปิด',
          fnOk: () => handleToggleModal(),
        };
      default:
        return;
    }
  };

  const date = new Date(find.accountMst.aboExpireDate);
  const formattedDate = thaiDate(date, 'dd MMMM yyyy');
  const content = handleModalContent();
  return (
    <div className="confirmpayment-container">
      {

        showModal && <Modal
          content={content.content}
          type={content.type}
          fnClose={() => setShowModal(false)}
          fnOk={content.fnOk}
          fnCancel={content.cancleBtn ? () => setShowModal(false) : null}
          closeBtn={content.closeBtn}
          okBtn={content.okBtn}
          okText={content.okText}
          cancleText="ยกเลิก" />
      }
      <div className="header">
        ตรวจสอบข้อมูลก่อนชำระเงิน
      </div>
      <div className="body mb-120">
        <Card className="price-card mt-3">
          <div className="card-body">
            {
              cart.data.entries.filter(excludeProductEntries).map(data => (
                <>
                  {
                    data.basePrice.value > 0 &&
                    <div className="product" key={data.aliasCode}>
                      <div className="name">{data.product.name}</div>
                      <div className="price">{handlePriceFormatting(data.basePrice.formattedValue)}</div>
                    </div>
                  }
                </>
              ))
            }
          </div>
        </Card>

        <RenewalOrderDetailCard
          cardText={CustomerTypeRenderMapping[customer.type]?.cardText}
          cardImg={CustomerTypeRenderMapping[customer.type]?.cardImg}
          title={CustomerTypeRenderMapping[customer.type]?.title}
          desc={CustomerTypeRenderMapping[customer.type]?.desc}       // for multi line description
          className="mt-3"
          style={null}
        />
        <RenewalPersonalInfoCard
          labelThai={{
            cardText: "ข้อมูลส่วนตัว",
            applicant: "ข้อมูลสมาชิก",
            sponsor: "ผู้สปอนเซอร์",
            expiryDate: "วันหมดอายุสมาชิก",
            telephoneNumber: "เบอร์โทรศัพท์",
            address: "ที่อยู่ (หลัก)",
          }}
          applicant={[find?.accountMst?.accountName, `#${find?.accountMst?.aboNum}`]}
          sponsor={[find?.sponsor?.sponsorName, `#${find?.sponsor?.sponsorABONo}`]}
          expiryDate={formattedDate}
          telephoneNumber={partyIndex !== -1 && find?.partyList[partyIndex]?.phoneList[0].phoneLocalNum.replace(/(\d{3})(\d{3})(\d+)/, '$1-XXX-$3')}
          address={[cart.data && cart.data.account.primaryParty.defaultBillingAddress.formattedAddress]}
          className="mt-3"
          style={null}
        />
      </div >
      <StickyBottom buttonProps={{ type: 'submit' }} buttonText="ชำระเงินทันที" isActive={isCalculated && accept} onClick={isCalculated && accept ? () => setRedirect(true) : null}
        secondaryButtonProps={{ type: 'submit' }} secondaryButtonText="ย้อนกลับ" secondaryIsActive secondaryOnClick={() => secondaryOnClick()}>
        <div className="home-registration-tnc-wrapper">
          <CustomCheckbox onChange={() => setAccept(!accept)} ref={checkboxRef} accept={accept} />
          <div className="home-registration-tnc-link">
            <div className="link" onClick={() => setShowConsent(true)}>{customer.type === 'abo' ? LABEL_ACCEPT_TNC_ABO_RENEWAL : LABEL_ACCEPT_TNC_MEMBER_RENEWAL}</div>
          </div>
        </div>
      </StickyBottom>
    </div >
  );
};

const PaymentConsent = ({ onClick, setAccept }) => {
  const { policy, customer } = useSelector(state => state);
  const [reachedBottom, setReachedBottom] = useState(false);
  const scrollRef = useRef(null)

  useEffect(() => {
    if (policy?.data?.contractDetail?.verbiage && scrollRef.current) {
      handleScroll(scrollRef)
    }
  }, [policy])

  const handleScroll = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e?.target || e.current;
    if (Math.floor(scrollHeight - scrollTop - 10) <= clientHeight) {
      setReachedBottom(true);
    } else {
      setReachedBottom(false);
    }
  };

  const onAcceptClick = () => {
    setAccept();
    onClick();
  }

  if (!policy.data) {
    return <div> <LoadingOverlay
      active={true}
      spinner
      text="Loading"
      styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', pointerEvents: 'none' } }}
    /></div>;
  }
  return (
    <div className="payment-consent-container">
      <div ref={scrollRef} className='container-inner' onScroll={handleScroll}>
        <Card>
          <div className="card-header">
            เงื่อนไขและข้อตกลง
          </div>
          <div className="card-body">
            <div className="header">
              เงื่อนไขการต่ออายุ{customer.type === 'abo' ? 'นักธุรกิจแอมเวย์' : 'สมาชิกแอมเวย์'}
            </div>
            <div>
              {ReactHtmlParser(policy.data.contractDetail.verbiage)}
            </div>
          </div>
        </Card>
      </div>
      <div className="card-footer">
        {reachedBottom &&
          <button className="away-button active" onClick={onAcceptClick}>ยอมรับ</button>
        }
        {!reachedBottom &&
          <button className="tnc-back-button" onClick={() => onClick()}>ย้อนกลับ</button>
        }
      </div>
    </div >
  );
};
